/* global axios */
import ApiClient from 'dashboard/api/ApiClient';

class SipChannelAPI extends ApiClient {
  constructor() {
    super('sip_inboxes', { accountScoped: true });
  }

  create(params) {
    return axios.post(this.url, params);
  }
}

export default new SipChannelAPI();
